import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddFinalState = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 14,
	viewBox: "0 0 21 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#4A5666",
		fillRule: "nonzero",
		children: [/* @__PURE__ */ _jsx("path", { d: "M10.5 0C16.263 0 21 3.069 21 7c0 .775-.184 1.517-.524 2.208l-.001-.054h-1.117C19.773 8.48 20 7.754 20 7c0-3.248-4.217-6-9.5-6S1 3.752 1 7s4.217 6 9.5 6a14.2 14.2 0 0 0 3.676-.47v1.033A15.4 15.4 0 0 1 10.5 14C4.737 14 0 10.931 0 7s4.737-7 10.5-7m0 2C15.156 2 19 4.144 19 7c0 .78-.287 1.508-.8 2.154l-.875-.001v-.528c.398-.461.633-.963.67-1.481L18 7c0-2.112-3.319-4-7.5-4S3 4.888 3 7s3.319 4 7.5 4q.265 0 .525-.01v1q-.261.01-.525.01C5.844 12 2 9.856 2 7s3.844-5 8.5-5" }), /* @__PURE__ */ _jsx("path", { d: "M16.25 7v2.75H19v1.5h-2.75V14h-1.5v-2.75H12v-1.5h2.75V7z" })]
	})
});
export default SvgAddFinalState;
